import React from 'react';
import { useTranslation } from 'react-i18next';

interface DisclaimerProps {
  variant?: 'banner' | 'card' | 'inline';
  showIcon?: boolean;
}

export default function Disclaimer({ variant = 'banner', showIcon = true }: DisclaimerProps) {
  const { t } = useTranslation();

  const baseClasses = {
    banner: 'bg-amber-50 border-l-4 border-amber-400 p-4',
    card: 'bg-white rounded-xl shadow-sm border border-amber-200 p-6',
    inline: 'text-sm text-gray-500',
  };

  const iconClasses = {
    banner: 'text-amber-400',
    card: 'text-amber-500',
    inline: 'text-gray-400',
  };

  return (
    <div className={baseClasses[variant]}>
      <div className={`flex ${variant === 'inline' ? 'items-center gap-2' : 'gap-3'}`}>
        {showIcon && (
          <div className={`flex-shrink-0 ${iconClasses[variant]}`}>
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
        )}
        <div>
          {variant !== 'inline' && (
            <h3 className="text-sm font-medium text-amber-800 mb-1">
              Important Notice
            </h3>
          )}
          <p className={`${variant === 'inline' ? '' : 'text-sm text-amber-700'}`}>
            {t('home.disclaimer')}
          </p>
        </div>
      </div>
    </div>
  );
}
